import Highlight from './highlight/highlight';
import Selection from './selection';
import {handleMouseEvent} from './mouseEventHandler';

export {
  handleMouseEvent,
  Highlight,
  Selection,
};



// WEBPACK FOOTER //
// ./src/selection/index.js